export const EVENT_TRACKING = {
	VIEWED_BUY_TAB: 'viewed_buy_tab',
	VIEWED_SELL_TAB: 'viewed_sell_tab',
	MANAGE_MODAL_OPENED: 'manage_modal_opened',
	EXPAND_ALL_CLICKED: 'expand_all_clicked',
	COLLAPSED_ALL_CLICKED: 'collapsed_all_clicked',
	FLOOR_MINI_MODAL_OPENED: 'floor_mini_modal_opened',
	BIN_MINI_MODAL_OPENED: 'bin_mini_modal_opened',
	COUNTER_MINI_MODAL_OPENED: 'counter_mini_modal_opened',
	HIGH_OFFER_MINI_MODAL_OPENED: 'high_offer_mini_modal_opened',
	STARTING_BID_MINI_MODAL_OPENED: 'starting_bid_mini_modal_opened',
	MINI_MODAL_OPENED: 'mini_modal_opened',
	MANAGE_MODAL_OPENED_LEGACY: 'manage_modal_opened_legacy',
	LEGACY_MODAL_OPENED: 'legacy_modal_opened',
	COPY_DEAL: 'deal_driver_copy_deal',
	SHARE_LINK: 'deal_driver_share_link',
};

export const GOODWILL_TRACKING = {
	VIEW_APPROVAL_REQUEST_MODAL: 'view_approval_request_modal',
	CLOSED_APPROVAL_REQUEST_MODAL: 'closed_approval_request_modal',
};

export const CARD_WRAPPER_CLASS = 'deal-driver-card';

export const ANCHORED_CARD_KEY = 'dealDriverAnchoredBidSale';

export const TAB_TITLE = {
	SELLER: 'Seller',
	BUYER: 'Buyer',
};
